import { PlayCircle, RotateCcw } from "lucide-react";
import { useNotify, useTranslate, useUserMenu } from "ra-core";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemTitle,
} from "@/components/ui/item";
import { useOnboarding } from "./OnboardingProvider";

const useActions = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const { openIntro, resetTips } = useOnboarding();
  const t = (key: string) => translate(`resources.onboarding.menu.${key}`);
  const reset = async () => {
    try {
      await resetTips();
      notify(t("tips_reset"));
    } catch {
      notify(t("tips_error"), { type: "error" });
    }
  };
  return { t, openIntro, reset };
};

/** Menu du compte, sur ordinateur : à côté de « Offre et couverture ». */
export const OnboardingMenuItems = () => {
  const userMenu = useUserMenu();
  const { t, openIntro, reset } = useActions();
  return (
    <>
      <DropdownMenuItem
        onClick={(event) => {
          // Le menu disparaît à sa fermeture : le focus reviendra à son bouton (celui que nomme le menu).
          const menu = event.currentTarget.closest("[role='menu']");
          const triggerId = menu?.getAttribute("aria-labelledby");
          userMenu?.onClose();
          openIntro(triggerId ? document.getElementById(triggerId) : null);
        }}
        className="flex items-center gap-2"
      >
        <PlayCircle />
        {t("replay")}
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => {
          userMenu?.onClose();
          void reset();
        }}
        className="flex items-center gap-2"
      >
        <RotateCcw />
        {t("tips")}
      </DropdownMenuItem>
    </>
  );
};

/** Page Paramètres, sur téléphone : en haut, là où l'on cherche de l'aide. */
export const OnboardingSettingsItems = () => {
  const { t, openIntro, reset } = useActions();
  return (
    <>
      <Item asChild size="sm" className="cursor-pointer">
        <button type="button" onClick={() => openIntro()} className="w-full text-left">
          <ItemContent>
            <ItemTitle className="font-normal">{t("replay")}</ItemTitle>
          </ItemContent>
          <ItemActions>
            <PlayCircle className="size-4 text-muted-foreground" />
          </ItemActions>
        </button>
      </Item>
      <Item asChild size="sm" className="cursor-pointer">
        <button
          type="button"
          onClick={() => void reset()}
          className="w-full text-left"
        >
          <ItemContent>
            <ItemTitle className="font-normal">{t("tips")}</ItemTitle>
          </ItemContent>
          <ItemActions>
            <RotateCcw className="size-4 text-muted-foreground" />
          </ItemActions>
        </button>
      </Item>
    </>
  );
};

/** Page Offre, pour l'invité : c'est là qu'il se demande ce que l'abonnement apporte. */
export const ReplayIntroLink = () => {
  const { t, openIntro } = useActions();
  return (
    <button
      type="button"
      onClick={() => openIntro()}
      className="text-sm font-medium underline underline-offset-4"
    >
      {t("replay")}
    </button>
  );
};
